export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              ゆうまデンタル
            </h3>
            <p className="text-gray-400 leading-relaxed text-sm">
              医療法人ゆうまデンタルクリニック<br />
              LIOデンタルクリニック<br />
              いくの歯科医院
            </p>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">診療時間</h4>
            <div className="space-y-3 text-gray-400 text-sm">
              <div>
                <p className="font-semibold text-white mb-1">医療法人ゆうまデンタルクリニック・LIOデンタルクリニック</p>
                <p>月・金: 10:00 - 14:00 / 15:30 - 19:30</p>
                <p>水・木・土: 9:00 - 13:00 / 14:00 - 18:00</p>
              </div>
              <div className="pt-2">
                <p className="font-semibold text-white mb-1">いくの歯科医院</p>
                <p>月〜金: 9:30 - 13:30 / 14:30 - 18:30</p>
                <p>土: 9:00 - 15:00</p>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">お問い合わせ</h4>
            <div className="space-y-4">
              <div>
                <p className="text-white text-sm font-semibold mb-2">医療法人ゆうまデンタルクリニック・LIOデンタルクリニック</p>
                <a href="tel:0784530828" className="flex items-center gap-2 text-teal-400 hover:text-teal-300 transition-colors cursor-pointer mb-1">
                  <i className="ri-phone-line"></i>
                  <span>078-453-0828</span>
                </a>
                <a href="mailto:yuhmadental@gmail.com" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-mail-line"></i>
                  <span className="text-xs">yuhmadental@gmail.com</span>
                </a>
              </div>
              <div className="pt-2">
                <p className="text-white text-sm font-semibold mb-2">いくの歯科医院</p>
                <a href="tel:0667776714" className="flex items-center gap-2 text-teal-400 hover:text-teal-300 transition-colors cursor-pointer mb-1">
                  <i className="ri-phone-line"></i>
                  <span>06-6777-6714</span>
                </a>
                <a href="mailto:ikunoshika@gmail.com" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-mail-line"></i>
                  <span className="text-xs">ikunoshika@gmail.com</span>
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">アクセス</h4>
            <div className="space-y-4 text-gray-400 text-sm">
              <div>
                <p className="font-semibold text-white mb-2">LIOデンタルクリニック</p>
                <p className="mb-2">〒658-0021<br />神戸市東灘区深江南町1-12-16<br />光南ハイツ1F</p>
              </div>
              <div className="pt-2">
                <p className="font-semibold text-white mb-2">いくの歯科</p>
                <p>〒544-0033<br />大阪市生野区勝山北1-3-19</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h4 className="font-bold text-lg mb-4">クリニックマップ</h4>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <p className="text-white text-sm font-semibold mb-3">LIOデンタルクリニック</p>
              <div className="rounded-lg overflow-hidden shadow-lg h-64">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.8!2d135.2667!3d34.7167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDQzJzAwLjEiTiAxMzXCsDE2JzAwLjEiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="LIOデンタルクリニックの地図"
                ></iframe>
              </div>
            </div>
            <div>
              <p className="text-white text-sm font-semibold mb-3">いくの歯科</p>
              <div className="rounded-lg overflow-hidden shadow-lg h-64">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.5!2d135.5333!3d34.6667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDQwJzAwLjEiTiAxMzXCsDMyJzAwLjEiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="いくの歯科の地図"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            &copy; 2024 医療法人ゆうまデンタルクリニック. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-500 text-sm hover:text-teal-400 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}